'use es6';

import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const DividerDiv = styled.div.withConfig({
  displayName: "Divider__DividerDiv",
  componentId: "sc-1bpm48h-0"
})(["border-left:1px solid ", ";height:33px;margin-left:8px;margin-right:8px;display:", ";"], BATTLESHIP, ({
  multiRow
}) => multiRow ? 'none' : 'inline-block');
export default function Divider({
  multiRow
}) {
  return /*#__PURE__*/_jsx(DividerDiv, {
    multiRow: multiRow
  });
}